module.exports = __webpack_public_path__ + "img/video1-poster-m.e5985052.png";